import {Inject} from "@angular/core";
import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'



export interface ICategorias extends IDataModel {
    codigo?:Number,
    nome?:string,
    img?: string,
    imgSrc?:string,
    comissao?:number,
    ordem?:number,

}

export class Categorias extends DataModel<ICategorias>  {
    constructor(private db: AngularFirestore) {
        super(db,'categorias');
    }

   getCategoria(codigo:Number,proc){
      let rt=null ;
      this.FDados.forEach(element => {
           if (element.codigo==codigo){
               rt = element;
               if (proc!=null) proc(rt);
               return rt;
           }
       });  

      /// nao esta na memoria ?
      if (rt==null){
         this.db.collection( this.tableNameFull,
           r => r.where("codigo","==",Number(codigo)) )
         .snapshotChanges()
         .subscribe( d => {
             console.log(d);
         })  
      }

   }

 updateOrInsert(id,item,proc,err){
        var old = id;
        item.codigo = Number(item.codigo);
        return super.updateOrInsert(item.id,item,r=>{
            if (proc) proc(r);
        },err);
    }
   

   gerarNovoCodigo(proc){
       this.getNewID('codigo_categoria',proc);
   }

}
